import ReportItemReceiveItem from "../../../../components/@reports/warehouse/ReportItemReceiveItem";

import { ReportContextProvider } from "../../../../context/ReportContext";

import { reportScopes, reportTypes } from "../../../../hooks/api/useReports";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

import { validationSchema, initialValues, advancedValidationSchema, advancedInitialValues } from "../../../../schema/reports/warehouse/itemReceiveItemSchema"

export default function ItemReceiveItemReport() {

    let routeType = routeTypes.admin

    return (
        <ReportContextProvider
            routeType={routeType}
            reportScope={reportScopes.warehouse}
            reportType={reportTypes.warehouse.itemReceiveItem.id}
            validationSchema={validationSchema}
            advancedValidationSchema={advancedValidationSchema}
            initialValues={initialValues}
            advancedInitialValues={advancedInitialValues}
        >
            <ReportItemReceiveItem
                routeType={routeType}
            />
        </ReportContextProvider>
    )
}       